import $ from "cash-dom";

$(function () {
    $('.show-hide-vendors').on('click', (e) => {
        e.preventDefault();

        let el = $(e.target).hasClass('show-hide-vendors') ?
            $(e.target) :
            $(e.target).closest('.show-hide-vendors');

        if (el.hasClass('show-more')) {
            $('.ppc-single-vendor.show-more-hideable.show-more-hidden').removeClass('show-more-hidden');

            el.removeClass('show-more').addClass('show-less');
        } else {
            $('.ppc-single-vendor.show-more-hideable').addClass('show-more-hidden');

            el.removeClass('show-less').addClass('show-more');
        }
    });
});